import React from 'react';
import EventGallery from '../components/EventGallery';

export default function EventGalleryPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <EventGallery />
    </div>
  );
}
